import React, { createContext, useContext, useState, useEffect } from 'react'; 
import { useParams } from 'react-router-dom';
import { useAuth } from './AuthContext/AuthContext';
import config from '../utils/config'

export const FormContext = createContext(); 

export const FormProvider = ({ children }) => {
    const { formId } = useParams();
    const { token, user } = useAuth();
    const [ propertyData, setPropertyData ] = useState({});
    const [currentFormId, setCurrentFormId] = useState(formId); // Add this line
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    // console.log("PropertyData In FormContext", propertyData);
    const [formData, setFormData] = useState({
      
        status: 'In Progress',
        address: {
          street: '',
          city: '',
          state: '',
          zip: '',
        },
        streetViewUrl: '',
        firstName: '', 
        lastName: '',
        buyer1Email: '',
        buyer1HomeAddress:
        {
          street: '',
          city: '',
          state: '',
          zip: '',
        },
        buyer1Phone: '',
        seller1Name: '',
        seller1Email: '',
        seller1Phone: '',
        seller2Name: '',
        seller2Email: '',
        seller2Phone: '',
        listingAgentName: '',
        listingAgentPhone: '',
        listingAgentEmail: '',
        sendToSeller: '',
        additionalTenants: {},
        tenantType: '',
        tenantTypeOtherText: '',
        tenants: [],
        propertyCounty: '',
        propertyDescription: '',
        propertyStreetName: '',
        propertyCity: '',
        propertyState: '',
        propertyZip: '',
        inclusionsRemoteControls: 'Any',

        // OTHER ITEMS PRE STEP
        inclusionsPreStep: {
          solarPanels: {
            included: false,
            description: 'Panels mounted on the property for generating electricity', 
            status: null, // leased, paidOff, financed, unsure
            solarPowerPlan: false,
            assumeSolarObligations: false,
          }, 
          waterSofteners: {
            included: false, 
            description: 'Systems that reduce water hardness by removing minerals',
            status: null // leased, paidOff, financed, unsure
          }, 
          securitySystems: {
            included: false, 
            description: 'Installed security monitoring and alarm systems',
            status: null // leased, paidOff, financed, unsure
          }, 
          satelliteSystems: {
            included: false, 
            description: 'Satellite dishes and associated equipment',
            status: null // leased, paidOff, financed, unsure
          }, 
          other: {
            included: false, 
            description: 'Any other items not listed. You can specify what these items are on the next step',
            status: null // leased, paidOff, financed, unsure
          },
          waterRights: {
            included: false,
            description: 'Rights to water on the property.',
            status: null
          },
          wellRights: {
            included: false,
            description: 'Rights to a water well on the property.',
            status: null
          }, 
          encumberedInclusionsManualText: '',
          encumberedInclusionsValues: '', 
          leasedItemsManualText: '',
          leasedItemsValues: '',
        },

        // WATER RIGHTS SECTION
        additionalWaterRights: '',
        deededWaterRights: '',
        deededWaterRightsDescription: 'N/A',
        typeOfDeed: 'N/A',
        otherWaterRights: '',
        otherWaterRightsDescription: 'N/A',
        wellRights: '',
        wellPermitNumber: 'N/A',
        waterStockCertificate: '',
        waterStockCertificateDescription: 'N/A',
        // waterRightsReview: 'yes',
        waterAddendumCertificate: 'no',
        isWell: '',
        copyOfWellPermit: 'no',

        // INCLUSIONS SECTION
        additionalPropertyInformation: '',
        attachedInclusions: 'yes',
        solarPanels: '',
        waterSofteners: '',
        securitySystems: '',
        satelliteSystems: '',
        otherInclusions: 'yes',
        otherInclusionsText: 'Washer, Dryer',
        encumberedInclusions: '',
        encumberedInclusionsText: '',
        leasedItemsText: '',
        exclusionsText: '',
        parkingFacility: '',
        storageFacility: '',

        // DATES DEADLINES ADDITIONAL DATES SECTION
        isHOA: null,
        addWaterAndMineralDates: null,

        // date fields from DatesDeadlines.jsx
        dateFields: {
          closingTimeframe: '',
          mecDate: '',
          time_deadline_to_send_contract:  {
            "date": "", 
            "checked": false,
            "scheduledWithVendor": false
        },
          alternative_earnest_money_deadline:  {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          record_title_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          record_title_objection_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          off_record_title_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          off_record_title_objection_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          title_resolution_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          right_of_first_refusal_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          association_document_deadline: {
            "date": "N/A",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          association_documents_termination_deadline: {
            "date": "N/A",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          seller_property_disclosure_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          lead_based_paint_disclosure_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          new_loan_application_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          new_loan_terms_or_termination_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          new_loan_availability_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          buyers_credit_information_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          disapproval_of_buyers_credit_information_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          existing_loan_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          existing_loan_termination_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          loan_transfer_approval_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          seller_or_private_financing_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          appraisal_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          appraisal_objection_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          appraisal_resolution_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          new_ilc_or_new_survey_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          new_ilc_or_new_survey_objection_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          new_ilc_or_new_survey_resolution_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          water_rights_examination_deadline: {
            "date": "N/A",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          mineral_rights_examination_deadline: {
            "date": "N/A",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
        inspection_termination_deadline: {
          "date": "",
          'dayOfWeek': '',
          'daysFromMEC': '',
          "checked": false,
          "scheduledWithVendor": false
        },
          inspection_objection_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          inspection_resolution_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          property_insurance_termination_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          due_diligence_documents_delivery_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          due_diligence_documents_objection_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          due_diligence_documents_resolution_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          conditional_sale_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          lead_based_paint_termination_deadline: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          closing_date: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          possession_date: {
            "date": "",
            'dayOfWeek': '',
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          possession_time: {
            "date": "",
            "checked": false,
            "scheduledWithVendor": false
        },
          acceptance_deadline_date: {
            "date": "",
            "dayOfWeek": "",
            'daysFromMEC': '',
            "checked": false,
            "scheduledWithVendor": false
        },
          acceptance_deadline_time: {
            "date": "",
            "checked": false,
            "scheduledWithVendor": false
        },
        }, 
        isLoan: null,
        uncommonPurchaseSituations: '',
        prices: [{ purchasePrice: '', earnestMoney: '', newLoanAmount: '', cashAtClosing: '', percentageDown: '', assumptionBalance: '', privateFinancing: '', sellerFinancing: '', totalPrice: '',}],
        isCashAtClosingVerified: '',
        sellerConcession: '',
        earnestMoneyPayable: 'Personal Check, Wire, or Cashiers Check',
        loanType: {
          conventional: false,
          FHA: false,
          VA: false,
          bond: false,
          other: false,
        },
        loanTypeOtherInput: '',
        sellerSelectsTitleCo: '',
        ownersExtendedCoverage: '',
        oecPayment: '',
        oecPaymentOther: '',
        transferOfTitle: '',
        transferOfTitleOther: '',
        ilcOrSurvey: '',
        ilcPayment: '',
        ilcPaymentText: 'Buyers may order and pay for an ILC or Survey at Buyers sole discretion',
        ilcOrder: '',

        // DISCLOSURE SECTION
        leasedItems: '',
        // encumberedInclusions: '',
        mineralRightsReview: '',
        conditionalUponSale: '',
        dueDiligenceDocuments: '',
        dueDiligenceDocumentsText: '',
        occupancyAgreements: '',
        occupancyAgreementsText: 'N/A',
        otherDocuments: '',
        otherDocumentsText: 'Any permits, blueprints, receipts for work, warranties, previous inspection reports, insurance claims, manuals of operation, and any other documents which are pertinent to the property',

        // CLOSING FEES
        standardClosingCosts: '',
        closingServicesFee: '',
        closingServicesFeeOtherInput: '',
        statusLetterFee: '',
        recordChangeFee: '',
        assessmentFee: '',
        salesAndUseTax: '',
        privateTransferFee: '',
        appraisalFee: '',
        otherFee: '',
        transferTax: '',
        waterTransferFeeAmount: '300.00',
        waterStockCert: '',
        waterDistrict: '',
        augmentationMembership: '',
        smallDomesticWaterCo: '',
        waterTransferFee: '',
        waterTransferFeeOther: '',
        waterTransferFeeOtherText: '',
        utilityTransferFee: '',
        taxCertFee: '',

        // PRORATION SECTION
        prorationTaxes: '',
        prorationTaxesOtherText: '',
        rentsType: '',
        otherProrations: '',
        associationsAssessments: '',
        associationAssessmentsText: '',
        isPcoa: '',
        primaryResidence: '',
        possessionPerDiem: '300', 
        additionalProvisions: '',
        termsAndConditions: '',
    });

// UPDATE DATES WITH STATIC TEXT
const updateDaysFromMECFields = (data) => {
  const updatedData = { ...data };
  const dateFields = updatedData.dateFields;

  Object.keys(dateFields).forEach((key) => {
    if (dateFields[key].daysFromMEC !== undefined && dateFields[key].daysFromMEC !== '') {
      if (key === 'acceptance_deadline_date') {
        if (!dateFields[key].daysFromMEC.includes('day/s from receiving contract')) {
          dateFields[key].daysFromMEC += ' day/s from receiving contract';
        }
      } else if (!key.includes('time')) {
        if (!dateFields[key].daysFromMEC.includes('days from MEC')) {
          dateFields[key].daysFromMEC += ' days from MEC';
        }
      }
    }
  });

  return updatedData;
};

    // INITIALIZE FORM DATA FROM PROPERTY DATA
    
    useEffect(() => {
        if (!propertyData) {
          console.error('Property data is undefined');
          return;
      }

      if (propertyData === 'unauthorized') {
          console.error('Error fetching property data:', propertyData.error);
          return;
      }

        if (propertyData.data && propertyData.data.ownerInfo && propertyData.data.ownerInfo.owner1FullName && formData.seller1Name === '' && formData.seller2Name === '') {
          setFormData(prevState => ({
              ...prevState,
              seller1Name: propertyData.data.ownerInfo.owner1FullName,
              seller2Name: propertyData.data.ownerInfo.owner2FullName,
          }));
      }
  }, [propertyData, formData.seller1Name, formData.seller2Name]); 

  useEffect(() => {
  //   if (!propertyData || !propertyData.data) {
  //     console.error('Property data or property data content is undefined');
  //     return;
  // }

    if (propertyData.data && propertyData.data.mlsHistory && propertyData.data.mlsHistory[0] && formData.listingAgentName === '' && formData.listingAgentEmail === '' && formData.listingAgentPhone === '') {
      setFormData(prevState => ({
          ...prevState,
          listingAgentName: propertyData.data.mlsHistory[0].agentName, 
          listingAgentEmail: propertyData.data.mlsHistory[0].agentEmail,
          listingAgentPhone: propertyData.data.mlsHistory[0].agentPhone,
      }));
    }
  }, [propertyData, formData.listingAgentName, formData.listingAgentEmail, formData.listingAgentPhone]);

    useEffect(() => {
      
      async function fetchData() {
        
          if (!formId || !token ) {
              // If formId is undefined, don't call fetchData
              // console.log("Form ID or token is missing");
              
              return;
          }
          try {
              // const response = await fetch(`http://localhost:5000/api/formdata/${formId}`, {
                // console.log("Fetching form data with token:", token); // Log token value
                const response = await fetch(`${config.apiBaseUrl}/formdata/${formId}`, {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}`
                  }
              });
              if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
              }
              const data = await response.json();
              setFormData(prevState => {
                  if (data.data) {
                      return {
                          ...prevState,
                          ...data.data
                      };
                  } else {
                      return {
                          ...prevState,
                          ...data
                      };
                  }
              });
          } catch (error) {
              console.error("Error fetching form data:", error);
          }
      }
      
      fetchData();
  }, [formId, token]); // Add formId as a dependency

  // PROPERTY DATA FETCH
  useEffect(() => {
    
    if (!formId || !token) {
        // console.log("Form ID or token is missing");
        return;
    }
    // fetch(`http://localhost:5000/api/formdata/${formId}`, {
      // console.log("Fetching property data with token:", token); // Log token value
      fetch(`${config.apiBaseUrl}/formdata/${formId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        setPropertyData(data.propertyData);
    })
    .catch(e => {
        console.error("Error fetching property data:", e);
    });
}, [formId, token]);

  // PROPERTY DATA CHANGE
  const handlePropertyDataChange = (data) => {
    setPropertyData(data);
  };

  // Handle address input change post Google Addition
const handleAddressChange = (event) => {
  setFormData(prevState => {
      if (prevState.data) {
          return {
              ...prevState,
              data: {
                  ...prevState.data,
                  address: event.target.value
              }
          };
      } else {
          return {
              ...prevState,
              address: event.target.value
          };
      }
  });
};

// INCLUSION PRE STEP FUNCTIONS
const handleItemToggle = (item) => {
  setFormData(prev => ({
      ...prev,
      inclusionsPreStep: {
          ...prev.inclusionsPreStep,
          [item]: {
              ...prev.inclusionsPreStep[item],
              included: !prev.inclusionsPreStep[item].included
          }
      }
  }));
};

// OLD
// const handleStatusChange = (item, status) => {
//   setFormData(prev => ({
//       ...prev,
//       inclusionsPreStep: {
//           ...prev.inclusionsPreStep,
//           [item]: {
//               ...prev.inclusionsPreStep[item],
//               status
//           }
//       }
//   }));
// };

// NEW
const handleStatusChange = (item, status) => {
  setFormData(prev => ({
      ...prev,
      inclusionsPreStep: {
          ...prev.inclusionsPreStep,
          [item]: {
              ...prev.inclusionsPreStep[item],
              status: prev.inclusionsPreStep[item].status === status ? null : status
          }
      }
  }));
};

const handleCheckboxChange = (item, field) => {
  setFormData(prevData => ({
    ...prevData,
    inclusionsPreStep: {
      ...prevData.inclusionsPreStep,
      [item]: {
        ...prevData.inclusionsPreStep[item],
        [field]: !prevData.inclusionsPreStep[item][field]
      }
    }
  }));
};

const handleInclusionsTextChange = (event) => {
  const { name, value } = event.target;
  setFormData(prevState => ({
    ...prevState,
    inclusionsPreStep: {
      ...prevState.inclusionsPreStep,
      [name]: value
    }
  }));
};


// Handle sendToSeller checkbox change
useEffect(() => {
  setFormData((prevData) => ({
      ...prevData,
      sendToSeller: prevData.listingAgentEmail ? 'yes' : 'no',
  }));
}, [formData.listingAgentEmail]);

const handleSendtoSellerCheckbox = (event) => {
  setFormData((prevData) => ({
      ...prevData,
      sendToSeller: event.target.checked ? 'yes' : 'no',
  }));
};

  const handleTermsAndConditionsCheckbox = (event) => {
    setFormData(prevState => ({
      ...prevState,
      termsAndConditions: event.target.checked ? 'yes' : 'no',
    }));
  };
  
    const handleInputChange = (e) => {
      const { name, value } = e.target; 
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      })); 
    };

    const handleBuyerAddressChange = (event) => {
      setFormData(prevState => {
          if (prevState.data) {
              return {
                  ...prevState,
                  data: {
                      ...prevState.data,
                      buyer1HomeAddress: event.target.value
                  }
              };
          } else {
              return {
                  ...prevState,
                  buyer1HomeAddress: event.target.value
              };
          }
      });
    };

    function handleClosingDateChange(field, value) {
      setFormData(prevState => ({
        ...prevState,
        dateFields: {
          ...prevState.dateFields,
          [field]: prevState.dateFields[field] === value ? '' : value,
        },
      }));
    }

    // HANDLE MISCELLANEOUS FUNCTIONS
    const handleAttachedInclusions = (field, value) => {
      setFormData(prevData => {
        if (value === 'no') {
          // Reset all related fields when 'No' is selected
          return {
            ...prevData,
            [field]: value,
            solarPanels: '',
            waterSofteners: '',
            securitySystems: '',
            satelliteSystems: '',
          };
        } else {
          // Only update the specific field when 'Yes' or other values are selected
          return {
            ...prevData,
            [field]: value,
          };
        }
      });
    };

    const handleAttachedInclusionsChange = (field, checked) => {
      setFormData(prevData => ({
          ...prevData,
          [field]: checked 
      }));
    };

    const handleOtherInclusions = (field, value) => {
      setFormData(prevData => {
        if (value === 'no') {
          // Reset all related fields when 'No' is selected
          return {
            ...prevData,
            [field]: value,
            otherInclusionsText: '',
          };
        } else {
          // Only update the specific field when 'Yes' or other values are selected
          return {
            ...prevData,
            [field]: value,
          };
        }
      });
    };

    const handleEncumberedInclusions = (field, value) => {
      setFormData(prevData => {
        if (value === 'no') {
          // Reset all related fields when 'No' is selected
          return {
            ...prevData,
            [field]: value,
            // encumberedInclusionsText: '',
          };
        } else {
          // Only update the specific field when 'Yes' or other values are selected
          return {
            ...prevData,
            [field]: value,
          };
        }
      });
    };

    // Update parkingFacility when propertyData changes
    useEffect(() => {
      if (propertyData?.data?.propertyInfo?.garageType) {
          setFormData(prevData => ({
              ...prevData,
              parkingFacility: propertyData.data.propertyInfo.garageType,
          }));
      }
    }, [propertyData]);

    // HANDLE WATER FUNCTIONS

    const handleAddtlWaterChange = (field, value) => {
      setFormData(prevData => {
        if (value === 'no') {
          // Reset all related fields when 'No' is selected
          return {
            ...prevData,
            [field]: value,
            deededWaterRights: '',
            // deededWaterRightsDescription: '',
            // typeOfDeed: '',
            otherWaterRights: '',
            // otherWaterRightsDescription: '',
            wellRights: '',
            // wellPermitNumber: '',
            // waterStockCertificate: '',
            // waterStockCertificateDescription: '',
            waterRightsReview: '',
          };
        } else {
          // Only update the specific field when 'Yes' or other values are selected
          return {
            ...prevData,
            [field]: value,
          };
        }
      });
    };


    const handleWaterRightsChange = (field, checked) => {
      setFormData(prevData => ({
          ...prevData,
          [field]: checked 
      }));
    };

    const handleWaterRightsTextChange = (e) => {
      const { name, value } = e.target; // Destructure name and value from event target
      setFormData(prevData => ({
          ...prevData,
          [name]: value
      }));
    };

    const handleWaterRightsReviewChange = (field, value) => {
      setFormData(prevData => ({
          ...prevData,
          [field]: value
      }));
    };

    // HANDLE TENANTS FUNCTIONS

  const handleTenantInputChange = (index, field, value) => {
    setFormData(prevData => {
        const updatedTenants = prevData.tenants.map((tenant, i) =>
            i === index ? { ...tenant, [field]: value } : tenant
        );
        return { ...prevData, tenants: updatedTenants };
    });
};

  const handleAddtlTenantChange = (field, value) => {
    setFormData(prevData => {
        // Check if additionalTenants is set to 'no'
        if (field === 'additionalTenants' && value === 'no') {
            return {
                ...prevData,
                [field]: value,
                tenants: [], // Reset tenants array
                tenantType: '', // Reset tenant type
            };
        }
        // Handle normal change
        return {
            ...prevData,
            [field]: value,
        };
    });
  };

  const handleTenantTypeChange = (name, value) => {
    setFormData(prevState => ({
        ...prevState,
        [name]: { ...prevState[name], [value]: !prevState[name][value] }
    }));
};

  const handleAddTenant = () => {
      setFormData(prevData => ({
          ...prevData,
          tenants: [...prevData.tenants, { tenantLastName: '', tenantFirstName: '', tenantPhone: '', tenantEmail: ''}]
      }));
  };

  const handleRemoveTenant = (index) => {
      setFormData(prevData => ({
          ...prevData,
          tenants: prevData.tenants.filter((_, i) => i !== index)
      }));
  };

// HANDLE DATES INPUT CHANGES
const handleDateInputChange = (e) => {
  const { name, value } = e.target; 
  let dayOfWeek = '';

  if (value !== 'N/A') {
      const [year, month, day] = value.split('-');
      const dateObject = new Date(year, month - 1, day);
      dayOfWeek = dateObject.toLocaleDateString('en-US', { weekday: 'long' });
  }

  setFormData(prevState => ({
    ...prevState, 
    dateFields: {
      ...prevState.dateFields, 
      [name]: {
        ...prevState.dateFields[name],
        // date: value,
        daysFromMEC: value,
        dayOfWeek: dayOfWeek
      }
    }
  })); 
};

const handleAdditionalDatesChange = (field, value) => {
  setFormData(prevData => ({
    ...prevData,
    [field]: value,
  }));
};

  const handleIsLoanChange = (value) => {
    setFormData(prevData => ({
        ...prevData,
        isLoan: value === 'yes'
    }));
};

const handleUncommonPurchaseSituationsChange = (value) => {
  setFormData(prevData => ({
      ...prevData,
      uncommonPurchaseSituations: value
  }));
};

const handlePriceInputChange = (field, value) => {
  setFormData(prevData => ({
      ...prevData,
      prices: prevData.prices.map((item, index) => 
          index === 0 ? {...item, [field]: value} : item
      )
  }));
};


  // This function assumes you are passing an event-like object
  const handleLoanTypeOtherInputChange = (event) => {
    // const { name, value } = event.target;
    setFormData(prevData => ({
        ...prevData,
        loanTypeOtherInput: event.target.value
    }));
  };


  const handleSellerConcessionChange = (e) => {
    const { name, value } = e.target; 
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    })); 
  };

  const handleEarnestMoneyPayableChange = (e) => {
    const { name, value } = e.target; 
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    })); 
  };

const handleRadioChange = (field, value) => {
  setFormData(prevData => ({
      ...prevData,
      [field]: value,
  }));
};

  const handleLoanTypeChange = (type, isSelected) => {
    setFormData(prevData => ({
      ...prevData,
      loanType: {
        ...prevData.loanType,
        [type]: isSelected // Only update the specified type
      }
    }));
  };

const handleTitleChange = (field, value) => {
  setFormData(prevData => ({
      ...prevData,
      [field]: value,
  }));
};

const handleOECPaymentOtherInputChange = (e) => {
  const { name, value } = e.target; 
  setFormData(prevState => ({
    ...prevState,
    [name]: value
  })); 
};

const handleIlcChange = (field, value) => {
  setFormData(prevData => ({
      ...prevData,
      [field]: value,
  }));
};

const handleIlcInputChange = (e) => {
  const { name, value } = e.target; 
  setFormData(prevState => ({
    ...prevState,
    [name]: value
  })); 
};

// DUE DILIGENCE AND DISCLOSURE SECTION
const handleDueDiligenceChange = (field, value) => {
  setFormData(prevData => {
    if (value === 'no') {
      // Reset all related fields when 'No' is selected
      return {
        ...prevData,
        [field]: value,
        dueDiligenceDocumentsText: '',
      };
    } else {
      // Only update the specific field when 'Yes' or other values are selected
      return {
        ...prevData,
        [field]: value,
      };
    }
  });
};

const handleOccupancyAgreementChange = (field, value) => {
  setFormData(prevData => {
    if (value === 'no') {
      // Reset all related fields when 'No' is selected
      return {
        ...prevData,
        [field]: value,
        occupancyAgreementsText: '',
      };
    } else {
      // Only update the specific field when 'Yes' or other values are selected
      return {
        ...prevData,
        [field]: value,
      };
    }
  });
};

const handleOtherDocumentsChange = (field, value) => {
  setFormData(prevData => {
    if (value === 'no') {
      // Reset all related fields when 'No' is selected
      return {
        ...prevData,
        [field]: value,
        otherDocumentsText: '',
      };
    } else {
      // Only update the specific field when 'Yes' or other values are selected
      return {
        ...prevData,
        [field]: value,
      };
    }
  });
};

const handleDisclosureChange = (field, value) => {
  setFormData(prevData => ({
      ...prevData,
      [field]: value,
  }));
};

// CLOSING COST FUNCTIONS

const handleClosingCostChange = (field, value) => {
  setFormData(prevData => ({
      ...prevData,
      [field]: value,
  }));
};

// Function to set formData to standard selections
const setStandardSelections = () => {
  setFormData({
      ...formData,
      standardClosingCosts: 'yes',
      closingServicesFee: 'half',
      statusLetterFee: 'seller',
      recordChangeFee: 'seller',
      assessmentFee: formData.dateFields.association_document_deadline.date === 'N/A' || formData.dateFields.association_document_deadline.date === '' ? 'n/a' : 'buyer',
      salesAndUseTax: 'buyer',
      privateTransferFee: 'n/a',
      appraisalFee: 'buyer',
      otherFee: 'seller',
      transferTax: 'seller',
      waterTransferFeeAmount: '300.00',
      waterStockCert: 'no',
      waterDistrict: 'yes',
      augmentationMembership: 'no',
      smallDomesticWaterCo: 'no',
      waterTransferFee: 'half',
      utilityTransferFee: 'seller',
      taxCertFee: '',
  });
}

// Function to reset formData
const resetFormData = () => {
  setFormData({
      ...formData,
      standardClosingCosts: 'no',
      closingServicesFee: '',
      statusLetterFee: '',
      recordChangeFee: '',
      assessmentFee: '',
      salesAndUseTax: '',
      privateTransferFee: '',
      appraisalFee: '',
      otherFee: '',
      transferTax: '',
      waterTransferFeeAmount: '',
      waterStockCert: '',
      waterDistrict: '',
      augmentationMembership: '',
      smallDomesticWaterCo: '',
      waterTransferFee: '',
      utilityTransferFee: '',
      taxCertFee: '',
  });
}

// END CLOSING COST FUNCTIONS

const handleClosingServicesFeeInputChange = (e) => {
  const { name, value } = e.target; 
  setFormData(prevState => ({
    ...prevState,
    [name]: value
  })); 
};

const handleProrationChange = (field, value) => {
  setFormData(prevData => ({
      ...prevData,
      [field]: value,
  }));
};

const handlePcoaChange = (field, value) => {
  setFormData(prevData => ({
      ...prevData,
      [field]: value,
  }));
};

const handlePossessionPerDiemChange = (e) => {
  const { name, value } = e.target; 
  setFormData(prevState => ({
    ...prevState,
    [name]: value
  })); 
};

const handleProvisionsChange = (e) => {
  const { name, value } = e.target; 
  setFormData(prevState => ({
    ...prevState,
    [name]: value
  })); 
};


const handleSave = async () => {

  if (!user) {
      console.error('No user data available.');
      setShowConfirmationModal(true);
      return;
  }

  if (!propertyData || Object.keys(propertyData).length === 0) {
    console.error('No property data available.');
    return;
  }

  const url = currentFormId 
  ? `${config.apiBaseUrl}/formdata/${currentFormId}` 
  : `${config.apiBaseUrl}/formdata`;

  const method = currentFormId ? 'PUT' : 'POST'; 

  // Update formData with static text in daysFromMEC fields
  const updatedFormData = updateDaysFromMECFields(formData);

  // Adjust the body of the request based on the shape of formData
  const body = { data: formId ? updatedFormData : updatedFormData, propertyData: propertyData };

  try {
      const response = await fetch(url, {
          method,
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(body)
      });

      const result = await response.json();

      if (response.ok) {

          // Update currentFormId with the id of the newly created document
          if (!currentFormId && result.formId) {
            setCurrentFormId(result.formId);
        }
      } else {
          throw new Error(result.message);
          
      }
        const anvilResponse = await fetch(`${config.apiBaseUrl}/fill-pdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({formData, propertyData}), // Send the form data as the body
      });
    
      if (anvilResponse.ok) {
        const pdfBlob = await anvilResponse.blob();
    
        // Create a Blob URL for the PDF
        const pdfUrl = URL.createObjectURL(pdfBlob);
    
        // Find the object element in the document
        const objectElement = document.getElementById('pdfObject');

        if (objectElement) {
          objectElement.data = pdfUrl;
        } else {
          console.error('pdfObject element not found');
        } 
      } else {
        console.error('Error:', anvilResponse.statusText);
      }
    
    } catch (error) {
      console.error('Failed to save or update form data:', error);
    }
};

    const handleCreateAccount = () => {
      localStorage.setItem('formData', JSON.stringify(formData));
      localStorage.setItem('propertyData', JSON.stringify(propertyData));
      // Route to create account page
      window.location.href = '/register'; 
    };

    const handleSignIn = () => {
      localStorage.setItem('formData', JSON.stringify(formData));
      localStorage.setItem('propertyData', JSON.stringify(propertyData));
      // Route to sign in page
      window.location.href = '/login';
    };



    return (
        <FormContext.Provider value={{ 
            formData, 
            formId, 
            currentFormId,
            setFormData,
            propertyData,
            handlePropertyDataChange,
            handleAddressChange,
            handleBuyerAddressChange,
            handleInputChange, 
            handleSendtoSellerCheckbox,
            handleTenantInputChange, 
            handleRemoveTenant,
            handleAddTenant,
            handleTenantTypeChange,
            handleDateInputChange,
            handleIsLoanChange, 
            handleUncommonPurchaseSituationsChange,
            handlePriceInputChange,
            handleSellerConcessionChange,
            handleEarnestMoneyPayableChange, 
            handleLoanTypeOtherInputChange,
            handleRadioChange, 
            handleLoanTypeChange, 
            handleTitleChange,
            handleOECPaymentOtherInputChange,
            handleIlcChange, 
            handleIlcInputChange,
            handleDisclosureChange, 
            handleClosingCostChange,
            setStandardSelections,
            resetFormData,
            handleClosingServicesFeeInputChange,
            handleProrationChange,
            handlePcoaChange,
            handlePossessionPerDiemChange,
            handleProvisionsChange,
            handleAddtlTenantChange,
            handleAddtlWaterChange, 
            handleWaterRightsChange,
            handleWaterRightsTextChange,
            handleWaterRightsReviewChange,
            handleSave, 
            handleAttachedInclusions,
            handleAttachedInclusionsChange,
            handleOtherInclusions,
            handleEncumberedInclusions, 
            handleDueDiligenceChange,
            handleOccupancyAgreementChange,
            handleOtherDocumentsChange,
            handleClosingDateChange,
            handleAdditionalDatesChange, 
            handleTermsAndConditionsCheckbox, 
            showConfirmationModal,
            setShowConfirmationModal,
            handleSignIn, 
            handleCreateAccount,
            setPropertyData,
            handleStatusChange, 
            handleItemToggle, 
            handleInclusionsTextChange, 
            handleCheckboxChange,
          }}>
            {children}
        </FormContext.Provider>
    ); 
}; 

export const useFormContext = () => useContext(FormContext); 